<template>
    <div>
        <v-scale-transition>
            <v-sheet :color="progressColor" class="progress-box elevation-10 body-2" v-show="progressModel">
                <v-container fluid class="pl-2 pr-2 pt-0">
                    <v-row dense>
                        <v-col cols="9" class="text-center pt-2">
                            <div class="vertical-center pl-3">
                                {{progressMessage}}
                            </div>
                        </v-col>
                        <v-col cols="3" class="display-1 text-center pt-2">
                            {{progressPercent}}%
                        </v-col>
                    </v-row>
                </v-container>
            </v-sheet>
        </v-scale-transition>
    </div>
</template>

<script>

    export default {

        data() {
            return {

                timeOut: 60,
                timer: null,

                // Live progress messages
                progressModel: false,
                progressMessage: null,
                progressPercent: 100,
                progressColor: 'primary',

                // Current status if status types come out of order
                currentStatus: null,
            }
        },

        mounted() {
            Bus.$on('live-progress', (notification) => {

                if (this.currentStatus === null) this.currentStatus = notification.status;

                window.clearTimeout(this.timer);

                this.progressMessage = notification.message;
                this.progressPercent = notification.percentComplete;

                if (notification.status === 'complete') {
                    this.progressColor = "success";
                    this.timeOut = 6000;

                    const audio = new Audio('/sounds/announcement.mp3');
                    audio.volume = 0.1;
                    audio.play();

                } else if (notification.status === 'aborted') {
                    this.progressColor = "error";
                    this.timeOut = 15000;
                    this.progressModel = false;
                    const audio = new Audio('/sounds/error.wav');
                    audio.volume = 0.1;
                    audio.play();

                } else if (notification.status === 'running') {

                    // Only display if current status is null or running
                    if (this.currentStatus === null || this.currentStatus === 'running') {
                        this.timeOut = 60 * 1000;
                        this.progressColor = "info";
                    }
                } else {
                    throw Error('Invalid notification status ' + notification.status);
                }

                this.progressModel = true;
                this.currentStatus = notification.status;
                this.setTimeOut();
            });
        },

        methods: {
            setTimeOut() {

                window.clearTimeout(this.timer);

                this.timer = window.setTimeout(() => {

                    this.progressModel = false;
                    this.currentStatus = null;

                }, this.timeOut)
            }
        }
    }

</script>

<style scoped>

    .progress-box {
        z-index: 99999;
        position: fixed;
        width: 450px;
        height: 55px;
        bottom: 2px;
        left: 2px;
        right: 0;
        margin-left: 2px;
        margin-right: auto;
    }

    .vertical-center {
        margin: 0;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }
</style>
